// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import socketio from "socket.io-client";
import VueSocketIO from "vue-socket.io";
import backendUrl from "./utils/backendUrl";
export const SocketInstance = socketio.connect(backendUrl());
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);
Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.use(VueSocketIO, SocketInstance);
new Vue({
  el: "#app",
  render(createElement) {
    return createElement(App);
  },
  directives: { infiniteScroll },
  template: "<App/>"
}).$mount("#app");
